export default "__VITE_ASSET__CDiG346u__"